import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "block w-full mb-4" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-4 w-full" }
const _hoisted_3 = { class: "inputTitle" }
const _hoisted_4 = { class: "inputField flex-grow" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "error-msg" }
const _hoisted_7 = { class: "inputTitle" }
const _hoisted_8 = { class: "inputField flex-grow" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "error-msg" }
const _hoisted_11 = { class: "inputTitle" }
const _hoisted_12 = { class: "inputField flex-grow" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "error-msg" }
const _hoisted_15 = { class: "block w-full col-span-2" }
const _hoisted_16 = { class: "inputTitle" }
const _hoisted_17 = { class: "helpText mt-2 mb-2" }
const _hoisted_18 = { class: "grid grid-cols-1 gap-4 w-full" }
const _hoisted_19 = { class: "flex justify-end" }

import {useI18n} from "vue-i18n";
import {useGlobalStore} from "@/stores/GlobalStore";
import {computed, onMounted, reactive, Ref, ref, toRef, watchEffect} from "vue";
import {email, helpers, required} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import GridInputFilter from "@/components/GridInputFilter.vue";
import {BryntumGrid} from "@bryntum/grid-vue-3";
import {Grid, Store} from "@bryntum/grid";
import {checkboxColumnConfig} from "@/AppConfig";
import Model from "@bryntum/grid/source/lib/Core/data/Model";
import {ErrorLocationType} from "@/utilities/enums/Enums";
import RecipientlistService from "@/utilities/services/entities/RecipientlistService";
import Recipient from "@/models/entities/Recipient";
import RecipientList from "@/models/entities/RecipientList";



export default /*#__PURE__*/_defineComponent({
  __name: 'RecipientEditPopup',
  props: {
  data: Object
},
  setup(__props) {

const {t} = useI18n();
const globalStore = useGlobalStore();
const recipientlistService = new RecipientlistService();
const props = __props
const popupData = toRef(props, 'data') as Ref<Recipient>;
watchEffect(()=>{
  popupData.value.displayName = `${popupData.value.firstName} ${popupData.value.lastName}`;
})


const rules = computed(() => {
  return {
    firstName: { required: helpers.withMessage(t('general.validation.required'), required) },
    lastName: { required: helpers.withMessage(t('general.validation.required'), required) },
    email: {
      required: helpers.withMessage(t('general.validation.required'), required),
      email: helpers.withMessage(t('general.validation.email'), email)
    },
  }
})
const v$ = ref(useVuelidate(rules, popupData.value));


const gridStore = new Store()
const grid = ref<{instance:{value:Grid}}|null>(null)
const useGridConfig = {
  emptyText: t("general.noEntries"),
  headerMenuFeature: false,
  height: "280px",
  columns: [
    {
      id: 'name',
      field : 'name',
      text: t('recipient.tabs.list.grid.name'),
      flex: 1,
      sortable: true
    },
    {
      id: 'desc',
      field : 'desc',
      text: t('recipient.tabs.list.grid.desc'),
      flex: 1,
      sortable: true
    },
  ],
  store: gridStore,
  listeners:{
    selectionChange(event: { selected:Array<Model>, deselected:Array<Model> }) {
      if(isInitalizing.value) return;
      for (const r of event.selected){
        popupData.value.listAssociations.recipientListIds.push((r.originalData as RecipientList).id)
      }
      for (const r of event.deselected ){
        popupData.value.listAssociations.recipientListIds = popupData.value.listAssociations.recipientListIds.filter(rid => rid !== (r.originalData as RecipientList).id)
      }
      popupData.value.listCount = popupData.value.listAssociations.recipientListIds.length;
    },
  },
  enableTextSelection: true,
  selectionMode : {
    row	  : true,
    checkbox: checkboxColumnConfig,
    showCheckAll : true,
    deselectFilteredOutRecords: true
  }
}
const gridConfig = reactive(useGridConfig)

const isInitalizing = ref<boolean>(true);

const setRecipientlistData = async () => {
  const lists = await recipientlistService.getForUser(ErrorLocationType.popup);
  if (!lists) return;

  gridStore.data = lists;

  // apply selection according to contains value
  if (popupData.value.id >= 0)
    grid.value!.instance.value.selectRows(popupData.value.listAssociations.recipientListIds);

  // disable swallowing of selection events
  isInitalizing.value = false;
}


onMounted(async ()=> {
  globalStore.modal.validator = {$validate:v$.value.$validate};

  await setRecipientlistData();
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('recipient.tabs.recipient.popups.edit.name')) + " * ", 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass({ error: v$.value.firstName.$errors.length })
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((popupData.value.firstName) = $event)),
              class: "w-full"
            }, null, 512), [
              [_vModelText, popupData.value.firstName]
            ]),
            _hoisted_5,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.firstName.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: error.$uid
              }, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(error.$message), 1)
              ]))
            }), 128))
          ], 2)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('recipient.tabs.recipient.popups.edit.lastName')) + " * ", 1),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: _normalizeClass({ error: v$.value.lastName.$errors.length })
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((popupData.value.lastName) = $event)),
              class: "w-full"
            }, null, 512), [
              [_vModelText, popupData.value.lastName]
            ]),
            _hoisted_9,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.lastName.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: error.$uid
              }, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(error.$message), 1)
              ]))
            }), 128))
          ], 2)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('recipient.tabs.recipient.popups.edit.email')) + " * ", 1),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            class: _normalizeClass({ error: v$.value.email.$errors.length })
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((popupData.value.email) = $event)),
              class: "w-full"
            }, null, 512), [
              [_vModelText, popupData.value.email]
            ]),
            _hoisted_13,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.email.$errors, (error) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "input-errors",
                key: error.$uid
              }, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(error.$message), 1)
              ]))
            }), 128))
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('recipient.tabs.recipient.popups.edit.recipientlists')), 1),
        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('recipient.tabs.recipient.popups.edit.helpText')), 1),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(GridInputFilter, {
              gridStore: _unref(gridStore),
              hideFilterButton: true
            }, null, 8, ["gridStore"])
          ]),
          _createVNode(_unref(BryntumGrid), _mergeProps({
            ref_key: "grid",
            ref: grid
          }, gridConfig, { readOnly: true }), null, 16)
        ])
      ])
    ])
  ]))
}
}

})